import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import FiveFactors from './Factors/FiveFactors'
import FourFactors from './Factors/FourFactors'
import ThreeFactors from './Factors/ThreeFactors'
import ManyNegative1 from './Negative/ManyNegative1'
import ManyNegative2 from './Negative/ManyNegative2'
import ManyNegative3 from './Negative/ManyNegative3'
import OneNegative from './Negative/OneNegative'
import TwoNegative from './Negative/TwoNegative'

const Bootcamp4Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'OneNegative':
      return <OneNegative {...props} />
    case 'TwoNegative':
      return <TwoNegative {...props} />
    case 'ThreeFactors':
      return <ThreeFactors {...props} />
    case 'FourFactors':
      return <FourFactors {...props} />
    case 'FiveFactors':
      return <FiveFactors {...props} />
    case 'ManyNegative1':
      return <ManyNegative1 {...props} />
    case 'ManyNegative2':
      return <ManyNegative2 {...props} />
    case 'ManyNegative3':
      return <ManyNegative3 {...props} />
    default:
      return <></>
  }
}

export default Bootcamp4Activities
